import SuperAdminMetaverseUser from "./SuperAdminMetaverseUser.container";

export default SuperAdminMetaverseUser;
